<script>
  import { fly } from "svelte/transition";
  import { tourFunctions } from "../tour-functions";

  export let linkto;
  export let click;
  export let text = "Logo"; // Default text

  function onclick() {
    click ? click() : tourFunctions.loadFirstScene('logo');
    tourFunctions.focus();
  }
</script>

<button
  on:click={onclick}
  transition:fly={{ y: -300, duration: 500 }}
  tabindex="0"
>
  <span
    alt={linkto ? "Go to our website" : "Load the starting scene"}
  >
    {text}
  </span>
</button>


<style>
  button {
    position: absolute;
    left: 20px;
    top: 20px;
    z-index: 750;
    cursor: pointer;
    background: none;
    border: none;
    margin: 0;
    padding: 0;
  }

  span {
    font-family: var(--font-heading), sans-serif;
    font-weight: bold;
    color: #fff;
    text-shadow: 0 0 5px #000;
    font-size: 3em;
  }
</style>
